import { Asterisk } from "lucide-react";

const LINES = [
  "Your next customer is online right now",
  "We help them find you",
  "Clicks are nice. Leads are better. Customers are the goal.",
  "Advertising that should pay for itself",
  "Stop boosting posts. Start getting customers.",
  "We build ads that make the phone ring",
];

export const Marquee = () => {
  const row = [...LINES, ...LINES];
  return (
    <div data-testid="punch-marquee" className="overflow-hidden border-b border-white/5 bg-[#07070C] py-6">
      <div className="animate-vp-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((l, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap font-display text-base font-extrabold uppercase tracking-[0.12em] text-zinc-500">
                  {l}
                </span>
                <Asterisk className="mx-8 h-5 w-5 shrink-0 text-purple-500" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
